export default {
    /* GET_MATERIALS
    ---------------------------------------------------------------
    */
    GET_MATERIALS_REQUEST: state => {
        state.materialsLoading = true
    },
    GET_MATERIALS_SUCCESS: (state, data) => {
        state.materials = data.results
        state.materialsLoading = false
    },
    GET_MATERIALS_FAILURE: state => {
        state.materialsLoading = false
    },
    GET_MATERIALS_PMS_TYPES: (state, data) => {
        state.materialsPmsTypes = data.results
    },
    /* GET_UNITS_OF_MEASURE
    ---------------------------------------------------------------
    */
    GET_UNITS_OF_MEASURE_SUCCESS: (state, data) => {
        state.unitsOfMeasure = data.results
    },
    SET_MATERIALS_FILTERS: (state, filters) => {
        state.filters = filters
    },
    GET_MATERIAL_TYPES: (state, data) => {
        state.materialTypes = data.results
    },
    CLEAR_MATERIALS_FILTERS: state => {
        state.filters = state.setInitialFilters()
    },
    SET_CANCEL_TOKEN: (state, token) => {
        state.cancelToken = token
    }
}